/* global Swiper */
// **********************************************************
// Highlighted Products
// **********************************************************

const highlightedProductsSliderElements = document.querySelectorAll('[data-slider="highlighted-products"]');

const highlightedProductsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1023: {
      slidesPerView: 3,
      spaceBetween: 25,
    },
  },
};

highlightedProductsSliderElements.forEach((el) => {
  const heroSliderParent = el.closest('.highlighted-products');
  const arrowRight = heroSliderParent.querySelector('.arrow-right');
  const arrowLeft = heroSliderParent.querySelector('.arrow-left');

  highlightedProductsSliderOptions.navigation.nextEl = arrowRight;
  highlightedProductsSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  new Swiper(el, highlightedProductsSliderOptions);
});

// **************************************************
// Add comparison
// **************************************************
const comparisonButtons = document.querySelectorAll('.recommended-products__list .compare-button, .highlighted-products__slider .compare-button');
comparisonButtons.forEach((button) => {
  button.addEventListener('click', (e) => {
    if (button.innerHTML !== button.dataset.altertext) {
      e.preventDefault();
      let compareCookie = getCookie('wc_compare');
      if (compareCookie) {
        compareCookie = JSON.parse(compareCookie);
        compareCookie.push(button.dataset.productid);
      } else {
        compareCookie = [button.dataset.productid];
      }
      setCookie('wc_compare', JSON.stringify(compareCookie));
    }
    // eslint-disable-next-line no-param-reassign
    button.innerHTML = button.dataset.altertext;
  });
});
